import React from 'react';
import { motion } from 'framer-motion';
import { Clapperboard } from 'lucide-react';

const CriticConsultation: React.FC = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0, transition: { duration: 0.8 } }}
      className="absolute inset-0 z-[60] flex items-center justify-center bg-black/70 backdrop-blur-md rounded-3xl"
    >
      <div className="relative flex flex-col items-center p-8 text-center">
        <motion.div
          animate={{ 
            rotateY: [0, 180, 360],
            scale: [1, 1.1, 1],
          }}
          transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
          className="mb-8"
        >
          <Clapperboard size={80} className="text-[#d4af37] drop-shadow-[0_0_20px_rgba(212,175,55,0.4)]" />
        </motion.div>
        
        <div className="space-y-4">
          <h2 className="font-marquee text-2xl md:text-3xl text-[#d4af37] tracking-[0.3em] uppercase opacity-90">
            Consulting the Critic
          </h2>
          
          <div className="flex justify-center items-center gap-2">
            <span className="text-[#fef3c7]/60 font-serif-elegant italic text-xl">
              Reviewing the archives
            </span>
            {/* The "Thinking" Dots */}
            <div className="flex gap-1.5 mt-1">
              {[0, 1, 2].map((i) => (
                <motion.div
                  key={i}
                  animate={{ opacity: [0.3, 1, 0.3] }}
                  transition={{ duration: 1.5, delay: i * 0.2, repeat: Infinity }}
                  className="w-1.5 h-1.5 bg-[#d4af37] rounded-full"
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default CriticConsultation;
